import { createDCHook, collapseDataFromCall } from '../client';
import { getVehicleBrands } from '../services/HemsPublicService';

export const useHemsPublicGetVehicleBrands = createDCHook(
  'getVehicleBrands',
  collapseDataFromCall(getVehicleBrands),
  { injectables: ['label', 'businessUnit'], flattenData: true },
  { maxAge: 300000 },
);
